import React, {useContext, useState} from 'react';
import {addCompany, addCompanyDetail, addCompanyState, addContact, addLog} from '../api/postApi';
import {FilterContext} from '../context/filterContext';
import {Tab, Tabs} from 'react-bootstrap';
import CardHeader from './CardHeader';
import CardCoverageFacility, {coverageFacility} from './CardCoverageFacility';
import CmsIcon from '../../../assests/img/cms-icon.svg?react';
import AddIcon from '../../../assests/img/add.svg?react';
import NoLogo from '../../../assests/img/no-logo.jpg?url';
import TextInput from './TextInput';
import Button from './Button';
import {updateField} from '../../Content';
import Underwriter from './Underwriter';
import AddUnderwriter from './AddUnderwriter';
import {toast} from 'react-toastify';
import {UserContext} from '../context/userContext';
import classNames from 'classnames';
import {AuthContext} from '../context/authContext';
import Popup from './Popup';


export interface newCardProps {
    onClose: ()=>void,
    onAddNewCard: ()=> void
}

export default function NewCard(props: newCardProps) {

    const {filterData} = useContext(FilterContext);
    const {data: {userId}} = useContext(UserContext);
    const {accounts} = useContext(AuthContext);

    const [underwriterData, setUnderwriterData]= useState({
        id: 0,
        name: '',
        title: '',
        phone: '',
        mobile: '',
        department: '',
        email: '',
        address: '',
        submissionEmail: '',
    });
    const [notes, setNotes] = useState('');
    const [name, setName] = useState('');
    const [coverage, setCoverage] = useState({id: 0, value: '', logo: ''});
    const [distribution, setDistribution] = useState('Direct');
    const [minimumCms, setMinimumCms] = useState('');
    const [minimumTiv, setMinimumTiv] = useState('');
    const [type, setType] = useState('Carrier');
    const [facilityTypes, setFacilityTypes] = useState([{id: 0, value: ''}]);
    const [uniqueReq, setUniqueReq] = useState('');
    const [loading, setLoading] = useState(false);
    const [addUnderwriter, setAddUnderwriter] = useState(false);
    const [companyId, setCompanyId] = useState(undefined);
    const [submissionRequirements, setSubmissionRequirements] = useState(['']);
    const [detailsEntered, setDetailsEntered] = useState(false);

    const addLogs = (log: string) => {
        addLog({logText: log, createdById: userId}, accounts);
    }

    const handleUpdateCoverage = async (id: number, value: string,
        field: coverageFacility, logo: string) => {
            if (field === coverageFacility.coverage) {
                setCoverage({id, value, logo});
            } else if (field === coverageFacility.facility) {
                setFacilityTypes([{id, value}]);
            }
        }

    const handleDistributionTypeUpdate = (reqBody: any,
        field: updateField) => {
            if (field === updateField.distribution) {
                setDistribution(reqBody.Distribution);
            } else if (field === updateField.type) {
                setType(reqBody.CompanyType);
            } else if (field === updateField.name) {
                setName(reqBody.value);
                setCompanyId(reqBody?.id);
            }
    }

    const validateNewCard = () => {
        let valid = false;
        if (name.trim().length === 0) {
            toast.error("Please enter name");
        // } else if (underwriterData.name.trim().length === 0) {
        //     toast.error("Please add or enter underwriter name");
        // }
        } else if (coverage.id === 0) {
            toast.error("Please select coverage");
        } else if (facilityTypes[0].id === 0) {
            toast.error("Please select facility type");
        } else {
            valid = true;
        }
        return valid;
    }

    const addNewCard = async () => {
        if (validateNewCard()) {
            setLoading(true);
            let contactId = 0;
            let companyIdSelected = 0;
            // const contactData = {
            //         name: underwriterData.name,
            //         phone: underwriterData.phone,
            //         mobile: underwriterData.mobile,
            //         email: underwriterData.email,
            //         address: underwriterData.address,
            //         submissionEmail: underwriterData.submissionEmail,
            //         title: underwriterData.title,
            //         department: underwriterData.department,
            //         CreatedById: userId,
            //     }
            //     const underwriterRes = await addContact(contactData, accounts);
            //     addLogs(`Added New Underwriter with Name - ${underwriterData.name} and Email - ${underwriterData.email}`)
            //     contactId = underwriterRes.data.value[0].id;
            if ((underwriterData.id === 0 || underwriterData.id.toString() === '0')
        && underwriterData.name.trim().length > 0) {
                const data = {
                    name: underwriterData.name,
                    phone: underwriterData.phone,
                    mobile: underwriterData.mobile,
                    email: underwriterData.email,
                    address: underwriterData.address,
                    submissionEmail: underwriterData.submissionEmail,
                    title: underwriterData.title,
                    department: underwriterData.department,
                    CreatedById: userId,
                }
                const underwriterRes = await addContact(data, accounts);
                addLogs(`Added New Underwriter with Name - ${underwriterData.name} and Email - ${underwriterData.email}`)
                contactId = underwriterRes.data.value[0].id;
            } else {
                contactId = underwriterData.id;
            }
            const companyData = {
                value: name,
                CompanyType: type,
                Distribution: distribution,
                Logo: null,
                CreatedById: userId
            }
            if (companyId === undefined) {
                try {
                  const res = await addCompany(companyData, accounts);

                  if (res.status === 201 && res.data?.value?.[0]) {
                    // ✅ New company successfully created
                    companyIdSelected = res.data.value[0].id;
                    addLogs(
                      `Added new company details with Name - ${name} with Distribution - ${distribution}, Type - ${type}`
                    );
                  } else if (res.status === 409) {
                    const duplicate = filterData.carrier.find(
                      (c) =>
                        (c as any).CompanyName?.toLowerCase() ===
                          name.toLowerCase() &&
                        (c as any).CompanyType === type &&
                        (c as any).Distribution === distribution
                    ) as any;
                    if (duplicate) {
                      companyIdSelected = duplicate.CompanyId ?? duplicate.id;
                      addLogs(
                        `Using existing company: ${duplicate.CompanyName}`
                      );
                    } else {
                      toast.error(
                        "Duplicate company exists but not found in carrier list"
                      );
                      return;
                    }
                  } else {
                    toast.error("Unexpected response from server");
                    return;
                  }
                } catch (err: any) {
                  // Only network errors / unexpected 5xx will reach here
                  toast.error("Error creating company");
                }
            } else {
                companyIdSelected = companyId;
            }

            const reqBody = {
                CompanyId: companyIdSelected,
                CoverageId: coverage.id,
                FacilityTypeId: facilityTypes[0].id,
                ContactId: contactId ? contactId: undefined,
                Notes: notes,
                SubmissionRequirement: submissionRequirements.join(','),
                MinimumCMS: minimumCms,
                MinimumTIV: minimumTiv,
                CompanyGroupId: `${companyIdSelected}${coverage.id}`,
                UniqueRequirements: uniqueReq,
                CreatedById: userId
            }
            const res = await toast.promise(addCompanyDetail(reqBody, accounts),
            {pending: 'Adding card data'});
            if (res.status === 201) {
                const reqBody = {
                    CompanyDetailId: res.data.value[0].CompanyDetailId,
                    CreatedById: userId
                }
                const data = await toast.promise(addCompanyState(`AddCompanyState`, reqBody,
                    accounts), {pending: 'Updating data'});
                if (data.status === 201) {
                    toast.success("Card details added succesfully");
                    addLogs(`Added New Card details for Name - ${name} with Coverage - ${coverage.value} for facility - ${facilityTypes[0].value}`)
                    props.onClose();
                    props.onAddNewCard();
                }
            }
            setLoading(false);
        }
    }

    const handleChangeUnderwriter = (id: number) => {
        const temp = {...underwriterData, id: id};
        setUnderwriterData(temp);
        setAddUnderwriter(true);
    }

    const handleSubmissionRequirements = (id: number) => {
        const isSelected = submissionRequirements.includes(id.toString());
        const temp = [...submissionRequirements];
        if (isSelected) {
            const index = submissionRequirements.findIndex((data)=>
                data === id.toString());
            if (~index) {
                temp.splice(index, 1);
            }
        } else {
            temp.push(id.toString());
        }
        setSubmissionRequirements(temp);
    }

    const isDetailsEntered = () => {
        let detailsEntered = false;
        if (name.trim().length > 0) {
            detailsEntered = true;
        }
        if (underwriterData.name.trim().length > 0) {
            detailsEntered = true;
        }
        if (coverage.id !== 0) {
            detailsEntered = true;
        }
        if (facilityTypes[0].id !== 0) {
            detailsEntered = true;
        }
        if (submissionRequirements.length > 1) {
            detailsEntered = true;
        }
        return detailsEntered;
    }

    const handleOnClose = () => {
       if (isDetailsEntered()) {
            setDetailsEntered(true);
       } else {
            props.onClose();
       }
    }

    return (
        <div className="card-detail-view-container">
            <Popup
                show={detailsEntered}
                onClose={()=> setDetailsEntered(false)}
                title='Are you sure you want to close?'
                primaryCtaText='Continue to Add'
                primaryCtaOnClick={()=> setDetailsEntered(false)}
                secondaryCtaOnClick={props.onClose}
                secondaryCtaText='Close'>
                    Your entered details have not been saved
                </Popup>
            {addUnderwriter?
            <AddUnderwriter
                onClose={()=> setAddUnderwriter(false)}
                underwriterData={(data: any)=> setUnderwriterData(data)}
                currentData={underwriterData}/>:
            <div className="card-detail-view-content">
             <CardHeader add={true}
                edit={true} onClose={handleOnClose} name={name}
                type={type} imgUrl={NoLogo}
                onUpdate={(reqBody, field)=>
                    handleDistributionTypeUpdate(reqBody, field)}
                distribution={distribution} view='detail'
                onWholesalerSelect={()=> null}
                groupId={0}
                onGroupIdSelected={()=> null}
                categories={filterData.categories}/>
                <div className="card-seperator detail"></div>
                <CardCoverageFacility edit={true}
                    view='detail' coverage={coverage}
                    facilityTypes={facilityTypes}
                    onUpdate={(id, value, field, logo)=>
                        handleUpdateCoverage(id, value, field, logo)}/>
                <div className="tiv-cms-container">
                    <div className="tiv-cms-content">
                        <span>$</span>
                        <span className="tiv-cms-label-text">Min TIV: 
                           <span className="tiv-cms-edit">
                                <TextInput text={minimumTiv} placeholder='Min TIV'
                                        onChange={(text)=> setMinimumTiv(text)} type='text'
                                        className='tiv-cms-tex-edit'/>
                            </span>
                        </span>
                    </div>
                    <div className="tiv-cms-content">
                        <CmsIcon width={16}/>
                        <span className="tiv-cms-label-text">Min CMS: 
                            <span className="tiv-cms-edit">
                                <TextInput text={minimumCms} placeholder='Min CMS'
                                    onChange={(text)=> setMinimumCms(text)} type='text'
                                    className='tiv-cms-tex-edit'/>
                            </span>
                        </span>
                    </div>
                </div>
                <div className="standard-req-container">
                    <div className="standard-req-items">
                    <span className='text-bold'>Standard Requirements:</span>
                    {filterData.submissionReq.map((req, index)=> {
                        return (
                            <span className={classNames('facility-type standar-req-item',
                                submissionRequirements.
                                    includes(req.id.toString())?
                                    'selected': 'not-selected', 'edit-mode')}
                                    key={`sub-req-${index}`}
                                    onClick={()=>
                                        handleSubmissionRequirements(req.id)}>
                                {req.value}
                            </span>
                    );
                    })}
                    </div>
                </div>
                <div className="unique-req-container">
                    <span className="text-bold">Unique Requirements: </span>
                        <TextInput type='text'
                            placeholder='Unique requirements'
                            onChange={(text)=>
                                setUniqueReq(text)} text={uniqueReq}
                            className='unique-req-edit-text'/>
                </div>
                <Tabs
                    defaultActiveKey="underwriter"
                    id="uncontrolled-tab-example"
                    className="card-detail-tabs"
                    >
                    <Tab eventKey="underwriter"
                        title={`Underwriter(${underwriterData.name.length? '1': '0'})`}
                        className="card-detail-tab"
                        style={{
                            border: 'none',
                        }}>
                        <div className="add-underwriter-container"
                            onClick={()=> setAddUnderwriter(true)}>
                            <AddIcon width={12}/>
                            <div className="add-underwriter-text">Add underwriter</div>
                        </div>
                        {underwriterData.name.length?
                        <Underwriter
                            data={[{
                                contact: underwriterData,
                                coverage: coverage,
                                facilityTypes: facilityTypes,
                            }]}
                            selectedCoverageId={coverage.id}
                            onSelectedId = {(id)=>
                                handleChangeUnderwriter(id)}/>: null}
                    </Tab>
                    <Tab eventKey="states" title={`States covered(0)`}>
                        <span className="card-coverage-name">
                            Add card to select states</span>
                    </Tab>
                    <Tab eventKey="files" title={`Files (0)`}>
                        <span className="card-coverage-name">
                            Add card to upload, view files</span>
                    </Tab>
                </Tabs>
                <div className="notes-container">
                    <div className="notes-title-icon">
                        <div className="text-bold">Notes</div>
                    </div>
                    <TextInput type='textarea' text={notes}
                    placeholder='Enter Notes Here'
                    className='card-detail-view-text-input'
                    onChange={(text: string)=>
                        setNotes(text)} rows={4} cols={96}/>
                </div>
                <div className="new-card-controls">
                    <Button type='secondary' onClick={handleOnClose}
                        buttonText='Cancel'/>
                    <Button type='primary' onClick={addNewCard}
                        buttonText='Add' loading={loading}/>
                </div>
            </div>}
        </div>
    );
}